import { useInfiniteQuery, useQuery } from 'react-query';

import { integrationApi } from '../api';

import integrationKeys from './models/integration/keys';
import { camelCaseApiResponse, getPageData } from './util';

/* QUERIES
========================================================= */
export const useProcoreOauthCallback = ({ code, pinsCompanyId, procoreCompanyId, options = {} }) => useQuery(
  integrationKeys.procoreOauthCallback(pinsCompanyId, procoreCompanyId, code),
  () => camelCaseApiResponse(() => integrationApi.getProcoreOauthCallback(pinsCompanyId, procoreCompanyId, code)),
  {
    staleTime: 1000 * 9,
    ...options
  }
);

export const useProcoreProjectDetails = ({ pinsAccessToken, companyId, procoreProjectId, options = {} }) => useQuery(
  integrationKeys.procoreProject(companyId, procoreProjectId),
  () => camelCaseApiResponse(() => integrationApi.getProcoreProjectDetails(pinsAccessToken, companyId, procoreProjectId)),
  options
);

export const useProcoreProjectRecords = ({
  pinsAccessToken,
  companyId,
  procoreProjectId,
  search,
  pageSize = 100,
  options = {}
}) => useInfiniteQuery(
  integrationKeys.procoreProjectRecords(companyId, procoreProjectId, search),
  ({ pageParam = 1 }) => camelCaseApiResponse(() => integrationApi.getProcoreProjectRecords(
    pinsAccessToken,
    companyId,
    procoreProjectId,
    { page: pageParam, pageSize },
    { search }
  )),
  {
    ...options,
    getNextPageParam: getPageData
  }
);

export const useProcoreProjectRecordDownload = ({ pinsAccessToken, companyId, procoreProjectId, search, options = {} }) => useQuery(
  integrationKeys.procoreProjectRecordsExcel(companyId, procoreProjectId, search),
  () => camelCaseApiResponse(() => integrationApi.getProcoreProjectRecordsExcel(pinsAccessToken, companyId, procoreProjectId, { search })),
  {
    enabled: false,
    ...options
  }
);

